import { List } from 'immutable'
import * as React from 'react'
import { any, fromJSX } from 'widgets-for-react'
import { FeaturedContentBlock } from '../../components/publicSite/blocks/custom_blocks/widgets/featuredContent'
import {
  ImageWithExpandablesBlockItem,
  ImageWithExpandablesBlockLayout
} from '../../components/publicSite/blocks/custom_blocks/widgets/imageWithExpandablesBlock'
import { UpdatesBlock } from '../../components/publicSite/blocks/custom_blocks/widgets/latestUpdates'
import { QuotesBlock } from '../../components/publicSite/blocks/custom_blocks/widgets/quotes'
import {
  FakeCMSState,
  FakeCtaBlockImage,
  FakeCtaBlockText,
  FakeDownloadBlock,
  FakeExpandBlock,
  FakeLinkBlock,
  FakeLinkGridImageBlock,
  FakeLinkGridTextBlock,
  FakeLinkGridTextImageBlock,
  FakeLinkGridTextImageWideBlock,
  FakeMediaBlockImages as FakeMediaBlock,
  FakeCardsBlock,
  FakePressReleaseBlock,
  FakeQuoteBlockPerson,
  FakeQuoteBlockText,
  FakeStoriesBlock,
  FakeTextBlock,
  FakeTextImageLeftBlock,
  FakeTextImageRightBlock
} from '../fake_data/buildingblocks'
import { applyBlock } from '../fake_data/fakeApplyBlock'
import { recruitmentBlock } from '../fake_data/fakeRecruitmentBlock'
import { footer } from '../fake_data/footer'
import { styleguideChapter, styleguideExample, styleguidePart, styleguideSection } from '../helpers.mod'

export const styleguideComponents = styleguideChapter({
  type: 'components',
  slug: 'components',
  title: 'Design Components',
  intro: ''
})(
  any([
    styleguideSection({ type: 'components', slug: 'components-apply', title: 'Apply Block', intro: '' })(
      styleguidePart({ title: '', intro: '' })(
        styleguideExample({ showExampleLabel: false, isFullScreen: false })(fromJSX(() => applyBlock()))
      )
    ),
    styleguideSection({ type: 'components', slug: 'components-cta', title: 'CTA Block', intro: '' })(
      any([
        styleguidePart({ title: 'Text only', intro: '' })(
          styleguideExample({ showExampleLabel: false, isFullScreen: false })(FakeCtaBlockText(FakeCMSState))
        ),
        styleguidePart({ title: 'Text & image', intro: '' })(
          styleguideExample({ showExampleLabel: false, isFullScreen: false })(FakeCtaBlockImage(FakeCMSState))
        )
      ])
    ),
    styleguideSection({
      type: 'components',
      slug: 'components-blocks-color',
      title: 'Block with grey background',
      intro: ''
    })(
      any([
        styleguidePart({ title: 'Image left - Text right', intro: '', extraClasses: 'block--color' })(
          styleguideExample({ showExampleLabel: false, isFullScreen: false })(
            any([
              FakeTextImageLeftBlock(FakeCMSState),
              FakeCtaBlockImage(FakeCMSState),
              FakeTextImageRightBlock(FakeCMSState),
              FakeMediaBlock(FakeCMSState),
              FakeCtaBlockText(FakeCMSState),
              FakeQuoteBlockText(FakeCMSState),
              fromJSX(() => footer())
            ])
          )
        )
      ])
    ),
    styleguideSection({ type: 'components', slug: 'components-download', title: 'Download Block', intro: '' })(
      any([
        styleguidePart({ title: 'Default', intro: '' })(
          styleguideExample({ showExampleLabel: false, isFullScreen: false })(FakeDownloadBlock(FakeCMSState))
        )
      ])
    ),
    styleguideSection({ type: 'components', slug: 'components-expand', title: 'Expand Block', intro: '' })(
      any([
        styleguidePart({ title: 'Default', intro: '' })(
          styleguideExample({ showExampleLabel: false, isFullScreen: false })(FakeExpandBlock(FakeCMSState))
        )
      ])
    ),
    styleguideSection({
      type: 'components',
      slug: 'components-featured-content',
      title: 'Featured content',
      intro: ''
    })(
      styleguidePart({ title: 'Image right', intro: '' })(
        styleguideExample({ showExampleLabel: false, isFullScreen: false })(
          fromJSX(() => (
            <FeaturedContentBlock
              isStyleguide={true}
              alignImage="right"
              label="News"
              title="KKR to Acquire Majority Stake in Refresco"
              intro="KKR has signed a definitive agreement to acquire a majority stake in Refresco, with Refresco’s existing investors maintaining a significant minority position."
              imageStyleguide={{
                src: '/styleguide/images/1920x1080.png',
                srcSet: '/styleguide/images/1920x1080.png 1920w',
                alt: 'alt text'
              }}
              button={{
                text: 'Read more',
                url: '/'
              }}
              secondaryButtonStyleguide={{
                text: 'Learn more',
                url: '/'
              }}
            />
          ))
        )
      )
    ),
    styleguideSection({
      type: 'components',
      slug: 'components-featured-content',
      title: 'Featured content',
      intro: ''
    })(
      styleguidePart({ title: 'Image left', intro: '' })(
        styleguideExample({ showExampleLabel: false, isFullScreen: false })(
          fromJSX(() => (
            <FeaturedContentBlock
              isStyleguide={true}
              alignImage="left"
              label="Vision & Values"
              title="Creating beverage solutions that matter"
              intro="When we look to the future with our clients and suppliers, we aim for positive changes with a lasting effect. We focus on three areas to drive sustainable action: people, products & processes."
              imageStyleguide={{
                src: '/styleguide/images/1920x1080.png',
                srcSet: '/styleguide/images/1920x1080.png 1920w',
                alt: 'alt text'
              }}
              button={{
                text: 'Read more',
                url: '/'
              }}
              secondaryButtonStyleguide={{
                text: 'Learn more',
                url: '/'
              }}
            />
          ))
        )
      )
    ),
    styleguideSection({ type: 'components', slug: 'components-footer', title: 'Footer', intro: '' })(
      any([
        styleguidePart({ title: 'Default', intro: '' })(
          styleguideExample({ showExampleLabel: false, isFullScreen: false })(fromJSX((_) => footer()))
        )
      ])
    ),
    styleguideSection({ type: 'components', slug: 'components-gallery', title: 'Image gallery block', intro: '' })(
      styleguidePart({ title: '', intro: '', extraClasses: '' })(
        styleguideExample({ showExampleLabel: false, isFullScreen: false })(
          fromJSX(() => (
            <section className="block block--background block--gallery grid--block">
              <div className="block__inner container container--s grid--block">
                <header className="block__header">
                  <h2 className="block__title title--m">Block title</h2>
                  <p className="block__intro">
                    Donec ullamcorper nulla non metus auctor fringilla. Vivamus sagittis lacus vel augue laoreet rutrum
                    faucibus dolor auctor.
                  </p>
                </header>
                <div className={'block__content'}>
                  <ul className="gallery" data-gallery-show-more="true">
                    <li className="gallery__item" data-gallery-more="+4">
                      <figure className="gallery__visual">
                        <img
                          src="http://placehold.it/800x800"
                          width="800"
                          height="800"
                          className="gallery__image"
                          alt=""
                        />
                      </figure>
                    </li>
                    <li className="gallery__item" data-gallery-more="+3">
                      <figure className="gallery__visual">
                        <img
                          src="http://placehold.it/800x800"
                          width="800"
                          height="800"
                          className="gallery__image"
                          alt="Donec ullamcorper nulla non metus auctor fringilla"
                        />
                      </figure>
                    </li>
                    <li className="gallery__item" data-gallery-more="+2">
                      <figure className="gallery__visual">
                        <img
                          src="http://placehold.it/800x800"
                          width="800"
                          height="800"
                          className="gallery__image"
                          alt="Nullam id dolor id nibh ultricies vehicula ut id elit"
                        />
                      </figure>
                    </li>
                    <li className="gallery__item" data-gallery-more="+1">
                      <figure className="gallery__visual">
                        <img
                          src="http://placehold.it/800x800"
                          width="800"
                          height="800"
                          className="gallery__image"
                          alt="Nullam id dolor id nibh ultricies vehicula ut id elit "
                        />
                      </figure>
                    </li>
                  </ul>
                </div>
              </div>
            </section>
          ))
        )
      )
    ),
    styleguideSection({ type: 'components', slug: 'components-updates', title: 'Latest updates', intro: '' })(
      any([
        styleguidePart({ title: 'Default', intro: '' })(
          styleguideExample({ showExampleLabel: false, isFullScreen: false })(
            fromJSX(() => (
              <UpdatesBlock
                title="From idea to aisle"
                isStyleguide={true}
                items={[
                  {
                    imageStyleguide: {
                      src: '/styleguide/images/1920x1080.png',
                      srcSet: '/styleguide/images/1920x1080.png 1920w',
                      alt: 'Deniz'
                    },
                    category: 'Story',
                    title: 'Stepping up our sustainability commitments in the UK',
                    link: '/'
                  },
                  {
                    imageStyleguide: {
                      src: '/styleguide/images/1920x1080.png',
                      srcSet: '/styleguide/images/1920x1080.png 1920w',
                      alt: 'Deniz'
                    },
                    category: 'Press release',
                    title: 'Refresco Group publishes Annual Report 2021',
                    link: '/'
                  },
                  {
                    imageStyleguide: {
                      src: '/styleguide/images/1920x1080.png',
                      srcSet: '/styleguide/images/1920x1080.png 1920w',
                      alt: 'Deniz'
                    },
                    category: 'Story',
                    title: 'Hosting our first virtual Supplier Day',
                    link: '/'
                  },
                  {
                    imageStyleguide: {
                      src: '/styleguide/images/1920x1080.png',
                      srcSet: '/styleguide/images/1920x1080.png 1920w',
                      alt: 'Deniz'
                    },
                    category: 'Press release',
                    title: 'KKR to acquire majority stake in Refresco',
                    link: '/'
                  }
                ]}
              />
            ))
          )
        ),
        styleguidePart({ title: 'Without images', intro: '' })(
          styleguideExample({ showExampleLabel: false, isFullScreen: false })(
            fromJSX(() => (
              <UpdatesBlock
                title="Our latest updates"
                isStyleguide={true}
                items={[
                  {
                    imageStyleguide: {
                      src: '/styleguide/images/1920x1080.png',
                      srcSet: '/styleguide/images/1920x1080.png 1920w',
                      alt: 'Deniz'
                    },
                    category: 'Story',
                    title: 'Stepping up our sustainability commitments in the UK',
                    link: '/'
                  },
                  {
                    category: 'Press release',
                    title: 'Refresco Group publishes Annual Report 2021',
                    link: '/'
                  },
                  {
                    category: 'Story',
                    title: 'Hosting our first virtual Supplier Day',
                    link: '/'
                  },
                  {
                    category: 'Press release',
                    title: 'KKR to acquire majority stake in Refresco',
                    link: '/'
                  }
                ]}
              />
            ))
          )
        )
      ])
    ),
    styleguideSection({ type: 'components', slug: 'components-linkgrid', title: 'Link Grid Block', intro: '' })(
      any([
        styleguidePart({ title: 'Text only', intro: '' })(
          styleguideExample({ showExampleLabel: false, isFullScreen: false })(FakeLinkGridTextBlock(FakeCMSState))
        ),
        styleguidePart({ title: 'Text & image (full width)', intro: '' })(
          styleguideExample({ showExampleLabel: false, isFullScreen: false })(
            FakeLinkGridTextImageWideBlock(FakeCMSState)
          )
        ),
        styleguidePart({ title: 'Text & image (circle)', intro: '' })(
          styleguideExample({ showExampleLabel: false, isFullScreen: false })(FakeLinkGridTextImageBlock(FakeCMSState))
        ),
        styleguidePart({ title: 'Image only', intro: '' })(
          styleguideExample({ showExampleLabel: false, isFullScreen: false })(FakeLinkGridImageBlock(FakeCMSState))
        )
      ])
    ),
    styleguideSection({ type: 'components', slug: 'components-links', title: 'Link List Block', intro: '' })(
      any([
        styleguidePart({ title: 'Default', intro: '' })(
          styleguideExample({ showExampleLabel: false, isFullScreen: false })(FakeLinkBlock(FakeCMSState))
        )
      ])
    ),
    styleguideSection({
      type: 'components',
      slug: 'components-image-expand',
      title: 'Image with Expandables Block',
      intro: ''
    })(
      any([
        styleguidePart({ title: 'Default - With 3 items', intro: '' })(
          styleguideExample({ showExampleLabel: false, isFullScreen: false })(
            fromJSX(() => (
              <ImageWithExpandablesBlockLayout
                blockIndex={0}
                isStyleguide
                title="Your global beverage provider"
                introduction="With over 75 production locations and offices in 13 different countries across 3 continents we can ensure close proximity and reliable service to our customers."
                items={List<ImageWithExpandablesBlockItem>([
                  {
                    title: 'Australia',
                    text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec ullamcorper nulla non metus auctor fringilla. Vestibulum id ligula porta felis euismod semper.',
                    link: { is_link_external: false, kind: 'link', target: '_self', title: 'Read more', url: '#' }
                  },
                  {
                    title: 'Europe',
                    text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec ullamcorper nulla non metus auctor fringilla. Vestibulum id ligula porta felis euismod semper.',
                    link: {
                      is_link_external: false,
                      kind: 'link',
                      target: '_self',
                      title: 'Read more about this',
                      url: '/'
                    }
                  },
                  {
                    title: 'North-America',
                    text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec ullamcorper nulla non metus auctor fringilla. Vestibulum id ligula porta felis euismod semper.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec ullamcorper nulla non metus auctor fringilla. Vestibulum id ligula porta felis euismod semper.',
                    link: { is_link_external: false, kind: 'link', target: '_self', title: 'Read more', url: '#' }
                  }
                ])}
              />
            ))
          )
        ),
        styleguidePart({ title: 'With 5 items', intro: '' })(
          styleguideExample({ showExampleLabel: false, isFullScreen: false })(
            fromJSX(() => (
              <ImageWithExpandablesBlockLayout
                blockIndex={1}
                isStyleguide
                title="Your global beverage provider"
                introduction="With over 75 production locations and offices in 13 different countries across 3 continents we can ensure close proximity and reliable service to our customers."
                items={List<ImageWithExpandablesBlockItem>([
                  {
                    title: 'Australia',
                    text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec ullamcorper nulla non metus auctor fringilla. Vestibulum id ligula porta felis euismod semper. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec ullamcorper nulla non metus auctor fringilla. Vestibulum id ligula porta felis euismod semper.',
                    link: { is_link_external: false, kind: 'link', target: '_self', title: 'Read more', url: '#' }
                  },
                  {
                    title: 'Europe',
                    text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec ullamcorper nulla non metus auctor fringilla. Vestibulum id ligula porta felis euismod semper.',
                    link: {
                      is_link_external: false,
                      kind: 'link',
                      target: '_self',
                      title: 'Read more about this',
                      url: '/'
                    }
                  },
                  {
                    title: 'North-America',
                    text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec ullamcorper nulla non metus auctor fringilla. Vestibulum id ligula porta felis euismod semper.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec ullamcorper nulla non metus auctor fringilla. Vestibulum id ligula porta felis euismod semper.',
                    link: { is_link_external: false, kind: 'link', target: '_self', title: 'Read more', url: '#' }
                  },
                  {
                    title: 'South-America',
                    text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec ullamcorper nulla non metus auctor fringilla. Vestibulum id ligula porta felis euismod semper. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec ullamcorper nulla non metus auctor fringilla. Vestibulum id ligula porta felis euismod semper.',
                    link: { is_link_external: false, kind: 'link', target: '_self', title: 'Read more', url: '#' }
                  },
                  {
                    title: 'Africa',
                    text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec ullamcorper nulla non metus auctor fringilla. Vestibulum id ligula porta felis euismod semper.',
                    link: { is_link_external: false, kind: 'link', target: '_self', title: 'Read more', url: '#' }
                  }
                ])}
              />
            ))
          )
        )
      ])
    ),
    styleguideSection({ type: 'components', slug: 'components-media', title: 'Media Block', intro: '' })(
      any([
        styleguidePart({ title: 'Default', intro: '' })(
          styleguideExample({ showExampleLabel: false, isFullScreen: false })(FakeMediaBlock(FakeCMSState))
        )
      ])
    ),
    styleguideSection({ type: 'components', slug: 'components-releases', title: 'Press release Block', intro: '' })(
      styleguidePart({ title: '', intro: '' })(
        styleguideExample({ showExampleLabel: false, isFullScreen: false })(
          fromJSX(() => (
            <section className="block block--releases">
              <div className="block__inner container container--m grid--block">
                <header className="block__header">
                  <h2 className="block__title title--l">Press releases</h2>
                </header>
                <div className="block__content">
                  <ul className="tabs">
                    {[2026, 2025, 2024, 2023, 2022].map((year, index) => (
                      <li key={year} className={`tabs__item tab${index == 0 ? ' tab--active' : ''}`}>
                        <button className="tab__button">{year}</button>
                      </li>
                    ))}
                  </ul>
                  <ul className="block__list grid">{FakePressReleaseBlock(FakeCMSState)}</ul>
                </div>
                <footer className="block__footer container container--m grid--gutter">
                  <a className="button button--primary" href="#">
                    All press releases
                  </a>
                </footer>
              </div>
            </section>
          ))
        )
      )
    ),
    styleguideSection({ type: 'components', slug: 'components-reports', title: 'Reports Block', intro: '' })(
      any([
        styleguidePart({
          title: 'All link types',
          intro:
            'Every action column renders whatever the CMS filled in: an uploaded file becomes a download icon, a URL becomes an external-link icon and a webcast becomes the volume icon. A column is only rendered when at least one row in the tab uses it, and a cell without content stays empty.'
        })(
          styleguideExample({ showExampleLabel: false, isFullScreen: false })(
            fromJSX(() => (
              <section className="block block--reports">
                <div className="block__inner container container--m grid--block">
                  <ul className="tabs tabs--3" role="tablist">
                    {['Annual reports', 'Half year reports', 'Quarterly reports'].map((tab, index) => (
                      <li key={tab} className={`tabs__item tab${index == 0 ? ' tab--active' : ''}`}>
                        <button className="tab__button">
                          <span className="tab-item__label">{tab}</span>
                        </button>
                      </li>
                    ))}
                  </ul>
                  <table>
                    <thead className="report__head">
                      <tr className="report__row">
                        <th className="report__title report__title--date">Date</th>
                        <th className="report__title report__title--details">Details</th>
                        <th className="report__title report__title--download">Add to calendar</th>
                        <th className="report__title report__title--download">Report</th>
                        <th className="report__title report__title--download">Presentation</th>
                        <th className="report__title report__title--download">Webcast</th>
                        <th className="report__title report__title--dropdown"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="report__row">
                        <td className="report__date">13-08-2026</td>
                        <td className="report__details">Uploaded files: calendar invite, report and presentation</td>
                        <td className="report__calendar calendar">
                          <a href="#" download target="_blank" aria-label="Download file" className="block__link block__link--calendar">
                            <span className="report__icon report__icon--calendar" aria-hidden="true" />
                          </a>
                        </td>
                        <td className="report__download">
                          <a href="#" download target="_blank" aria-label="Download file">
                            <span className="report__icon report__icon--download" aria-hidden="true" />
                          </a>
                        </td>
                        <td className="report__download">
                          <a href="#" download target="_blank" aria-label="Download presentation">
                            <span className="report__icon report__icon--download" aria-hidden="true" />
                          </a>
                        </td>
                        <td className="report__download" />
                        <td className="report__info calendar">
                          <button className="calendar__toggler">
                            <span className="calendar__icon" aria-hidden="true" />
                          </button>
                        </td>
                      </tr>
                      <tr className="report__row">
                        <td className="report__date">14-05-2026</td>
                        <td className="report__details">Links to an external page instead of a file</td>
                        <td className="report__calendar calendar" />
                        <td className="report__download">
                          <a href="#" aria-label="Open report">
                            <span className="report__icon report__icon--link" aria-hidden="true" />
                          </a>
                        </td>
                        <td className="report__download">
                          <a href="#" aria-label="Open presentation">
                            <span className="report__icon report__icon--link" aria-hidden="true" />
                          </a>
                        </td>
                        <td className="report__download" />
                        <td className="report__info calendar">
                          <button className="calendar__toggler">
                            <span className="calendar__icon" aria-hidden="true" />
                          </button>
                        </td>
                      </tr>
                      <tr className="report__row">
                        <td className="report__date">26-02-2026</td>
                        <td className="report__details">Webcast recording next to a downloadable report</td>
                        <td className="report__calendar calendar" />
                        <td className="report__download">
                          <a href="#" download target="_blank" aria-label="Download file">
                            <span className="report__icon report__icon--download" aria-hidden="true" />
                          </a>
                        </td>
                        <td className="report__download" />
                        <td className="report__download">
                          <a href="#" aria-label="Open webcast">
                            <span className="report__icon report__icon--webcast" aria-hidden="true" />
                          </a>
                        </td>
                        <td className="report__info calendar">
                          <button className="calendar__toggler">
                            <span className="calendar__icon" aria-hidden="true" />
                          </button>
                        </td>
                      </tr>
                      <tr className="report__row">
                        <td className="report__date">06-11-2025</td>
                        <td className="report__details">Announcement without any file or link</td>
                        <td className="report__calendar calendar" />
                        <td className="report__download" />
                        <td className="report__download" />
                        <td className="report__download" />
                        <td className="report__info calendar">
                          <button className="calendar__toggler">
                            <span className="calendar__icon" aria-hidden="true" />
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </section>
            ))
          )
        ),
        styleguidePart({
          title: 'Row with the details expanded',
          intro: 'The toggler in the last column opens a second row underneath, with the date and the body text from the CMS.'
        })(
          styleguideExample({ showExampleLabel: false, isFullScreen: false })(
            fromJSX(() => (
              <section className="block block--reports">
                <div className="block__inner container container--m grid--block">
                  <table>
                    <thead className="report__head">
                      <tr className="report__row">
                        <th className="report__title report__title--date">Date</th>
                        <th className="report__title report__title--details">Details</th>
                        <th className="report__title report__title--download">Report</th>
                        <th className="report__title report__title--dropdown"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="report__row">
                        <td className="report__date">13-08-2026</td>
                        <td className="report__details">An overview of the 2026 rebranding</td>
                        <td className="report__download">
                          <a href="#" download target="_blank" aria-label="Download file">
                            <span className="report__icon report__icon--download" aria-hidden="true" />
                          </a>
                        </td>
                        <td className="report__info calendar">
                          <button className="calendar__toggler calendar__toggler--open">
                            <span className="calendar__icon" aria-hidden="true" />
                          </button>
                        </td>
                      </tr>
                      <tr>
                        <td className="calendar__content" colSpan={7}>
                          <time className="calendar__date">August 13, 2026</time>
                          <p>
                            Integer posuere erat a ante venenatis aliquet. Vivamus sagittis lacus vel augue laoreet
                            rutrum faucibus dolor auctor. Donec id elit non mi porta gravida at eget metus.
                          </p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </section>
            ))
          )
        )
      ])
    ),
    styleguideSection({ type: 'components', slug: 'components-cards', title: 'Cards Block', intro: '' })(
      styleguidePart({ title: '', intro: '' })(
        styleguideExample({ showExampleLabel: false, isFullScreen: false })(FakeCardsBlock(FakeCMSState))
      )
    ),
    styleguideSection({ type: 'components', slug: 'components-quote', title: 'Quote Block', intro: '' })(
      any([
        styleguidePart({ title: 'Quote, attribution & buttons', intro: '' })(
          styleguideExample({ showExampleLabel: false, isFullScreen: false })(FakeQuoteBlockPerson(FakeCMSState))
        ),
        styleguidePart({ title: 'Text only', intro: '' })(
          styleguideExample({ showExampleLabel: false, isFullScreen: false })(FakeQuoteBlockText(FakeCMSState))
        )
      ])
    ),
    styleguideSection({ type: 'components', slug: 'components-quotes', title: 'Quotes', intro: '' })(
      styleguidePart({ title: 'Multiple quotes', intro: '' })(
        styleguideExample({ showExampleLabel: false, isFullScreen: false })(
          fromJSX(() => (
            <QuotesBlock
              title="Meet our people"
              isStyleguide={true}
              quotes={[
                {
                  imageStyleguide: {
                    src: '/styleguide/images/1920x1080.png',
                    srcSet: '/styleguide/images/1920x1080.png 1920w',
                    alt: 'Deniz'
                  },
                  person: 'Deniz',
                  person_function: 'Plant Manager',
                  quote: 'I make it my business to foster a personal connection with my staff.',
                  btn: {
                    url: '/',
                    label: 'Read his story'
                  }
                },
                {
                  imageStyleguide: {
                    src: '/styleguide/images/1920x1080.png',
                    srcSet: '/styleguide/images/1920x1080.png 1920w',
                    alt: 'Walt'
                  },
                  person: 'Walt Whitman',
                  person_function: 'Plant Manager',
                  quote: 'Keep your face always toward the sunshine - and shadows will fall behind you.'
                },
                {
                  imageStyleguide: {
                    src: '/styleguide/images/1920x1080.png',
                    srcSet: '/styleguide/images/1920x1080.png 1920w',
                    alt: 'Muhammad'
                  },
                  person: 'Muhammad Ali',
                  person_function: 'Plant Manager',
                  quote: 'The man who views the world at 50 the same as he did at 20 has wasted 30 years of his life.'
                }
              ]}
            />
          ))
        )
      )
    ),
    styleguideSection({
      type: 'components',
      slug: 'components-recruit',
      title: 'Recruitment Process Block',
      intro: ''
    })(
      styleguidePart({ title: '', intro: '' })(
        styleguideExample({ showExampleLabel: false, isFullScreen: false })(fromJSX(recruitmentBlock))
      )
    ),
    styleguideSection({ type: 'components', slug: 'components-spacer', title: 'Custom spacer block', intro: '' })(
      styleguidePart({ title: '', intro: '' })(
        styleguideExample({ showExampleLabel: false, isFullScreen: false })(
          fromJSX(() => (
            <section className="block block--custom-spacer">
              <div className="block__inner" />
            </section>
          ))
        )
      )
    ),
    styleguideSection({ type: 'components', slug: 'components-stories', title: 'Stories Block', intro: '' })(
      styleguidePart({ title: '', intro: '' })(
        styleguideExample({ showExampleLabel: false, isFullScreen: false })(
          fromJSX(() => (
            <section className="block block--stories">
              <div className="block__inner">
                <header className="block__header container container--s grid--gutter">
                  <h2 className="block__title title--l">Dolor Justo Sollicitudin Porta</h2>
                </header>
                <div className="block__content">
                  <div className="block__container container container--m grid--gutter">
                    <ul className="block__list grid">{FakeStoriesBlock(FakeCMSState)}</ul>
                  </div>
                  <footer className="block__footer container container--m grid--gutter">
                    <a className="button button--primary" href="/">
                      Luctus vitae
                    </a>
                  </footer>
                </div>
              </div>
            </section>
          ))
        )
      )
    ),
    styleguideSection({ type: 'components', slug: 'components-text', title: 'Text Block', intro: '' })(
      any([
        styleguidePart({ title: 'Default', intro: '' })(
          styleguideExample({ showExampleLabel: false, isFullScreen: false })(FakeTextBlock(FakeCMSState))
        )
      ])
    ),
    styleguideSection({ type: 'components', slug: 'components-text-image', title: 'Text Image Block', intro: '' })(
      any([
        styleguidePart({ title: 'Image left - Text right', intro: '' })(
          styleguideExample({ showExampleLabel: false, isFullScreen: false })(FakeTextImageLeftBlock(FakeCMSState))
        ),
        styleguidePart({ title: 'Image right - Text left', intro: '' })(
          styleguideExample({ showExampleLabel: false, isFullScreen: false })(FakeTextImageRightBlock(FakeCMSState))
        )
      ])
    ),
    styleguideSection({ type: 'components', slug: 'components-timeline', title: 'Timeline Block', intro: '' })(
      styleguidePart({ title: '', intro: '' })(
        styleguideExample({ showExampleLabel: false, isFullScreen: false })(
          fromJSX(() => (
            <section className="block block--timeline">
              <div className="block__inner container container--m grid--block">
                <header className="block__header container container--m">
                  <h2 className="block__title title--l">From idea to aisle</h2>
                  <div className="block__intro">
                    We are Refresco, a global independent beverage solutions provider. Serving drinks from idea to
                    aisle.
                  </div>
                </header>
                <div className="block__content">
                  <ul className="block__list">
                    <li className="block__item block__item--has-visual">
                      <div className="item__content">
                        <div className="item__visual">
                          <img
                            src="/styleguide/images/720x720.png"
                            data-src="/styleguide/images/720x720.png"
                            data-srcset="/styleguide/images/360x360.png 360w,/styleguide/images/720x720.png 720w"
                            data-sizes="auto"
                            className="item__image"
                            alt=""
                          />
                        </div>
                        <div className="item__message">
                          <h3 className="item__title title--m">Timeline item title</h3>
                          <div className="item__intro">
                            Main card content goes here — copy, data, form fields or whatever the card is composing.
                          </div>
                        </div>
                      </div>
                    </li>
                    <li className="block__item block__item--has-visual">
                      <div className="item__content">
                        <div className="item__visual">
                          <img
                            src="/styleguide/images/720x720.png"
                            data-src="/styleguide/images/720x720.png"
                            data-srcset="/styleguide/images/360x360.png 360w,/styleguide/images/720x720.png 720w"
                            data-sizes="auto"
                            className="item__image"
                            alt=""
                          />
                        </div>
                        <div className="item__message">
                          <h3 className="item__title title--m">Timeline item title</h3>
                          <div className="item__intro">
                            Main card content goes here — copy, data, form fields or whatever the card is composing.
                          </div>
                        </div>
                      </div>
                    </li>
                    <li className="block__item">
                      <div className="item__content">
                        <div className="item__message">
                          <h3 className="item__title title--m">Text-only timeline item</h3>
                          <div className="item__intro">
                            Maecenas faucibus mollis interdum. Vestibulum id ligula porta felis euismod semper. Cum
                            sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.
                          </div>
                        </div>
                      </div>
                    </li>
                    <li className="block__item">
                      <div className="item__content">
                        <div className="item__message">
                          <img src="/styleguide/images/360x360.png" className="item__icon" alt="" />
                          <h3 className="item__title title--m">Timeline item with an icon</h3>
                          <div className="item__intro">
                            Maecenas faucibus mollis interdum. Vestibulum id ligula porta felis euismod semper. Cum
                            sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </section>
          ))
        )
      )
    )
  ])
)
